(function () {
  if (window.__sibrilleCartDrawerFallbackLoaded) return;
  window.__sibrilleCartDrawerFallbackLoaded = true;

  var BUSY_ATTR = 'data-sibrille-cart-fallback-busy';
  var FALLBACK_ID = 'sibrille-cart-fallback-drawer';

  function cartAddUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function cartChangeUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) || '/cart/change.js';
  }

  function isCartAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    var action = form.getAttribute('action') || '';
    try {
      action = new URL(action, window.location.origin).pathname;
    } catch (error) {
      return false;
    }

    return action.indexOf('/cart/add') !== -1;
  }

  function shouldSkipSubmitter(submitter) {
    if (!(submitter instanceof HTMLElement)) return false;

    return Boolean(
      submitter.closest('.shopify-payment-button') ||
        submitter.closest('[data-shopify="payment-button"]') ||
        submitter.matches('[name="checkout"], [formaction*="/checkout"]')
    );
  }

  function canThemeHandleCartAdd(form) {
    return Boolean(
      form.closest('product-form-component') &&
        customElements.get('product-form-component') &&
        customElements.get('cart-drawer-component') &&
        customElements.get('cart-items-component') &&
        customElements.get('cart-quantity-selector-component')
    );
  }

  function formDataFor(form, submitter) {
    try {
      if (submitter instanceof HTMLElement) return new FormData(form, submitter);
    } catch (error) {
      // Older browsers do not support submitter-aware FormData.
    }

    return new FormData(form);
  }

  function cartSectionIds() {
    var ids = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (element) {
      var id = element.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });

    return ids;
  }

  function addSectionsToFormData(formData) {
    var ids = cartSectionIds();
    if (!ids.length) return;

    formData.delete('sections');
    formData.append('sections', ids.join(','));
    formData.set('sections_url', window.location.pathname);
  }

  async function fetchCart() {
    try {
      var response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function updateCartBubble(count) {
    if (typeof count !== 'number') return;

    document.querySelectorAll('[data-testid="cart-bubble"]').forEach(function (bubble) {
      bubble.textContent = String(count > 99 ? '99+' : count);
      bubble.classList.remove('hidden');
      bubble.closest('.cart-bubble')?.classList.remove('visually-hidden');
    });
  }

  function dispatchCartUpdate(cart, sourceId, data, sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || data,
          sourceId: sourceId || 'sibrille-cart-drawer-fallback',
          data: {
            source: 'sibrille-cart-drawer-fallback',
            itemCount: Number(data && data.quantity) || 1,
            productId: String(data && data.product_id ? data.product_id : ''),
            variantId: String(data && data.id ? data.id : ''),
            sections: sections || {},
          },
        },
      })
    );
  }

  function waitForCustomElement(name, timeout) {
    if (customElements.get(name)) return Promise.resolve(true);

    return Promise.race([
      customElements.whenDefined(name).then(function () {
        return true;
      }),
      new Promise(function (resolve) {
        setTimeout(function () {
          resolve(false);
        }, timeout);
      }),
    ]);
  }

  async function isThemeCartDrawerReady() {
    var component = document.querySelector('cart-drawer-component');
    if (!component) return false;

    var ready = await Promise.all([
      waitForCustomElement('cart-drawer-component', 1000),
      waitForCustomElement('cart-items-component', 1000),
      waitForCustomElement('cart-quantity-selector-component', 1000),
    ]);

    return ready.every(Boolean) && typeof component.open === 'function';
  }

  async function openThemeCartDrawer() {
    if (!(await isThemeCartDrawerReady())) return false;

    var component = document.querySelector('cart-drawer-component');
    if (!component) return false;

    component.setAttribute('auto-open', '');

    if (typeof component.open === 'function') {
      component.open();
    } else if (typeof component.showDialog === 'function') {
      component.showDialog();
    }

    var openDialog = component.querySelector('[data-testid="cart-drawer-dialog"], dialog');
    return Boolean(openDialog && openDialog.open);
  }

  function setThemeCartAutoOpen(enabled) {
    var component = document.querySelector('cart-drawer-component');
    if (!component) return;

    if (enabled) {
      component.setAttribute('auto-open', '');
    } else {
      component.removeAttribute('auto-open');
    }
  }

  function closeThemeDrawerNative() {
    var dialog = document.querySelector('cart-drawer-component dialog[open]');
    if (dialog && typeof dialog.close === 'function') dialog.close();
  }

  function money(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function fallbackMarkup(cart) {
    var items = (cart && cart.items) || [];
    var currency = cart && cart.currency;

    if (!items.length) {
      return '<p class="sibrille-cart-fallback__empty">Your cart is empty.</p>';
    }

    return (
      '<div class="sibrille-cart-fallback__items">' +
      items
        .map(function (item, index) {
          var line = index + 1;
          var image = item.image
            ? '<img src="' +
              item.image +
              '&width=120" alt="' +
              escapeHtml(item.product_title || item.title || '') +
              '">'
            : '';
          return (
            '<div class="sibrille-cart-fallback__item" data-cart-fallback-line="' +
            line +
            '">' +
            image +
            '<div><p class="sibrille-cart-fallback__title">' +
            escapeHtml(item.product_title || item.title || '') +
            '</p><div class="sibrille-cart-fallback__qty" data-cart-fallback-quantity="' +
            item.quantity +
            '"><button type="button" data-cart-fallback-qty="-1" aria-label="Decrease quantity">-</button><span>' +
            item.quantity +
            '</span><button type="button" data-cart-fallback-qty="1" aria-label="Increase quantity">+</button><button type="button" data-cart-fallback-remove aria-label="Remove item">Remove</button></div><p class="sibrille-cart-fallback__price">' +
            money(item.final_line_price, currency) +
            '</p></div></div>'
          );
        })
        .join('') +
      '</div><div class="sibrille-cart-fallback__summary"><span>Subtotal</span><strong>' +
      money(cart.total_price, currency) +
      '</strong></div><a class="sibrille-cart-fallback__checkout" href="/checkout">Checkout</a>'
    );
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      }[character];
    });
  }

  function ensureFallbackDrawer() {
    var existing = document.getElementById(FALLBACK_ID);
    if (existing) return existing;

    var style = document.createElement('style');
    style.textContent =
      '.sibrille-cart-fallback{position:fixed;inset:0;z-index:2147483640;pointer-events:none}.sibrille-cart-fallback.is-open{pointer-events:auto}.sibrille-cart-fallback__backdrop{position:absolute;inset:0;background:rgb(0 0 0 / .36);opacity:0;transition:opacity .2s ease}.sibrille-cart-fallback.is-open .sibrille-cart-fallback__backdrop{opacity:1}.sibrille-cart-fallback__panel{position:absolute;top:0;right:0;width:min(420px,100vw);height:100dvh;background:#fff;color:#111;box-shadow:-16px 0 40px rgb(0 0 0 / .18);transform:translateX(100%);transition:transform .24s ease;display:flex;flex-direction:column}.sibrille-cart-fallback.is-open .sibrille-cart-fallback__panel{transform:translateX(0)}.sibrille-cart-fallback__header{display:flex;align-items:center;justify-content:space-between;padding:20px;border-bottom:1px solid #eee}.sibrille-cart-fallback__header h2{margin:0;font-size:20px}.sibrille-cart-fallback__close{border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer}.sibrille-cart-fallback__body{padding:20px;overflow:auto;flex:1}.sibrille-cart-fallback__item{display:grid;grid-template-columns:72px 1fr;gap:14px;padding:14px 0;border-bottom:1px solid #eee}.sibrille-cart-fallback__item img{width:72px;height:72px;object-fit:cover;border-radius:6px}.sibrille-cart-fallback__title{margin:0 0 6px;font-weight:600}.sibrille-cart-fallback__qty{display:inline-flex;align-items:center;gap:10px;margin:2px 0 6px;color:#333}.sibrille-cart-fallback__qty button{border:1px solid #ddd;background:#fff;color:#111;min-width:32px;height:32px;padding:0 10px;cursor:pointer}.sibrille-cart-fallback__qty button[data-cart-fallback-remove]{font-size:12px}.sibrille-cart-fallback__price{margin:0 0 4px;color:#555}.sibrille-cart-fallback__summary{display:flex;justify-content:space-between;gap:16px;padding-top:18px;font-size:16px}.sibrille-cart-fallback__checkout{display:block;margin-top:18px;padding:14px 18px;text-align:center;background:#111;color:#fff;text-decoration:none;border-radius:4px}.sibrille-cart-fallback__empty{margin:0;color:#555}';
    document.head.appendChild(style);

    var drawer = document.createElement('div');
    drawer.id = FALLBACK_ID;
    drawer.className = 'sibrille-cart-fallback';
    drawer.innerHTML =
      '<div class="sibrille-cart-fallback__backdrop" data-cart-fallback-close></div><aside class="sibrille-cart-fallback__panel" role="dialog" aria-modal="true" aria-labelledby="sibrille-cart-fallback-title"><div class="sibrille-cart-fallback__header"><h2 id="sibrille-cart-fallback-title">Cart</h2><button class="sibrille-cart-fallback__close" type="button" aria-label="Close cart" data-cart-fallback-close>&times;</button></div><div class="sibrille-cart-fallback__body"></div></aside>';
    drawer.addEventListener('click', function (event) {
      var target = event.target instanceof HTMLElement ? event.target : null;
      if (!target) return;

      if (target.hasAttribute('data-cart-fallback-close')) {
        drawer.classList.remove('is-open');
        return;
      }

      var item = target.closest('[data-cart-fallback-line]');
      if (!item) return;

      var line = Number(item.getAttribute('data-cart-fallback-line'));
      var quantityElement = item.querySelector('[data-cart-fallback-quantity]');
      var quantity = Number(quantityElement && quantityElement.getAttribute('data-cart-fallback-quantity'));

      if (target.hasAttribute('data-cart-fallback-remove')) {
        updateFallbackLine(line, 0);
        return;
      }

      if (target.hasAttribute('data-cart-fallback-qty')) {
        var delta = Number(target.getAttribute('data-cart-fallback-qty'));
        updateFallbackLine(line, Math.max(0, quantity + delta));
      }
    });
    document.body.appendChild(drawer);
    return drawer;
  }

  function openFallbackDrawer(cart) {
    closeThemeDrawerNative();
    var drawer = ensureFallbackDrawer();
    var body = drawer.querySelector('.sibrille-cart-fallback__body');
    if (body) body.innerHTML = fallbackMarkup(cart);
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
  }

  async function updateFallbackLine(line, quantity) {
    var drawer = ensureFallbackDrawer();
    if (drawer.hasAttribute(BUSY_ATTR)) return;

    drawer.setAttribute(BUSY_ATTR, '');

    try {
      var response = await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line: line, quantity: quantity }),
        credentials: 'same-origin',
      });
      var cart = await response.json();
      if (!response.ok || cart.errors) {
        throw new Error(cart.errors || 'Unable to update cart.');
      }
      updateCartBubble(cart.item_count);
      openFallbackDrawer(cart);
    } catch (error) {
      window.alert(error.message || 'Unable to update cart.');
    } finally {
      drawer.removeAttribute(BUSY_ATTR);
    }
  }

  async function addToCart(formData, sourceElement, submitter) {
    addSectionsToFormData(formData);

    if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
      submitter.disabled = true;
    }

    try {
      var response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
        credentials: 'same-origin',
      });
      var data = await response.json().catch(function () {
        return null;
      });

      if (!response.ok || !data || data.status) {
        throw new Error((data && (data.description || data.message)) || 'Unable to add this item to cart.');
      }

      var cart = await fetchCart();
      var sections = data.sections || {};
      var themeReady = await isThemeCartDrawerReady();

      if (!themeReady) setThemeCartAutoOpen(false);
      dispatchCartUpdate(cart, sourceElement && sourceElement.id, data, sections);
      if (!themeReady) setThemeCartAutoOpen(true);
      updateCartBubble(cart && cart.item_count);

      if (!(await openThemeCartDrawer())) {
        openFallbackDrawer(cart);
      }
    } catch (error) {
      window.alert(error.message || 'Unable to add this item to cart.');
    } finally {
      if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
        submitter.disabled = false;
      }
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isCartAddForm(form)) return;
      if (shouldSkipSubmitter(event.submitter)) return;
      if (canThemeHandleCartAdd(form)) return;
      if (form.hasAttribute(BUSY_ATTR)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      form.setAttribute(BUSY_ATTR, '');
      addToCart(formDataFor(form, event.submitter), form, event.submitter).finally(function () {
        form.removeAttribute(BUSY_ATTR);
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target instanceof Element ? event.target.closest('a[href*="/cart/add"]') : null;
      if (!link || link.hasAttribute(BUSY_ATTR)) return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.pathname.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var formData = new FormData();
      url.searchParams.forEach(function (value, key) {
        formData.append(key, value);
      });
      link.setAttribute(BUSY_ATTR, '');
      addToCart(formData, link, link).finally(function () {
        link.removeAttribute(BUSY_ATTR);
      });
    },
    true
  );
})();
